exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.form-time-entry[data-v-3c86529e]{height:100%}div.content[data-v-3c86529e]{padding-top:58px;padding-bottom:67px;background-color:#fff;min-height:100%}h4[data-v-3c86529e]{text-align:left;margin-bottom:0;text-transform:uppercase;font-weight:700}.photos-section[data-v-3c86529e]{background-color:#0c2340}.photos-section h4[data-v-3c86529e]{color:#fff}", ""]);

// exports
